import React from 'react';
import { NavLink } from 'react-router-dom';
import { size } from 'lodash';

import { BaseCard } from '../baseCard/baseCard';
import Role from '../role/role';
import { MdOutlineWc as CandidatesIcon } from 'react-icons/md';
import { avatarOptions } from '../avatar/avatar';
// Use the same color mapping as dashboard clients section
import { ensureProjectColor } from '../avatar/avatar';

import styles from './projectCard.module.scss';
import { routesPath } from '../../constants/routesPath';

export const ProjectCard = ({ client, project, onRemove, onEdit, color, onClick, colors }) => {
  return (
    <>
      {project ? (
        <div className={styles.projectCard}>
          <BaseCard
            item={project}
            color={color}
            avatar={{ ...avatarOptions(project, 'project'), size: 40 }}
            title={project.title}
            subhead={client?.title}
            // link={routes.projectPipeline(project.client.id, project.id)}
            onEdit={onEdit}
            editLabel="Project Settings"
            size={'medium'}
            onRemove={onRemove}
            onClick={onClick}
          >
            <div className={styles.contentWrapper}>
              <NavLink
                className={styles.candidates}
                to={routesPath.projectPipeline(project.id, project.pipeline_id)}
              >
                <CandidatesIcon size={20} /> {project.projects_pipeline_stages_users?.length || 0} Candidates
              </NavLink>
              <Role className={project.minimum_level}>{project.minimum_level}</Role>
            </div>
          </BaseCard>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

// ProjectCard.propTypes = {
//   project: React.PropTypes.object.isRequired,
// };
